import classnames from 'classnames';
import BookieLogo, { LOGO_SIZE } from '../bookie-logo/bookie-logo';
import Link from '../link';
import styles from './style/promo-code-dropdown.module.css';
import INavigationLink from '../../interfaces/navigation-link';

interface ILinkProps {
  links: INavigationLink[];
  callback?: (text: string) => void;
  label: string;
}

const PromoCodeDropdown = ({
  links,
  callback,
  label
}: ILinkProps): JSX.Element | null => {
  if (!links || !links.length) {
    return null;
  }

  return (
    <div data-testid="promo-code-container" className={styles.container}>
			{links.map(({ url, text, icon = '', isSelected }) => {
        return (
          <Link
            className={classnames(
              styles.promoCodeItem,
              isSelected ? styles.selected : ''
            )}
            preCallback={() => callback?.(label ? `${label} - ${text}` : text)}
            to={url}
            key={text}
            data-testid="promo-code-item">

						<BookieLogo
              className={styles.bookieLogo}
              bookieCode={icon}
              size={LOGO_SIZE.SMALL} />

						<div className={styles.promoCodeItemText}>{text}</div>
					</Link>);

      })}
		</div>);

};

export default PromoCodeDropdown;